// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// const ScrollToTop = () => {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     if ('scrollRestoration' in window.history) {
//       window.history.scrollRestoration = 'manual';
//     }

//     const scrollToTop = () => {
//       // 1. Browser window will scroll to top
//       window.scrollTo(0, 0);

//       // 2. Specific scrolling div will scroll to top (Admin and Customer pages)
//       const container = document.getElementById("main-content-area");
//       if (container) {
//         container.scrollTo(0, 0);
//       }
//     };

//     // 10ms delay to ensure page is rendered
//     const timeoutId = setTimeout(scrollToTop, 10);
//     return () => clearTimeout(timeoutId);
//   }, [pathname]);

//   return null;
// };

// export default ScrollToTop;

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const scrollToTop = () => {
      // 1. General Window Reset
      window.scrollTo(0, 0);

      // 2. Customer Area Reset
      const customerArea = document.getElementById("customer-scroll-area");
      if (customerArea) {
        customerArea.scrollTo(0, 0);
      }

      // 3. Admin Area Reset
      const adminArea = document.getElementById("admin-scroll-area");
      if (adminArea) {
        adminArea.scrollTo(0, 0);
      }
    };

    // Small delay for DOM update
    const timeoutId = setTimeout(scrollToTop, 10);
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;